import React, { useState, useEffect } from 'react';

import './SecondsCounter.scss';
import image from '../../styles/assets/icons/lifebuoy-white.svg';

import { Button } from '../basic/Button/Button';

interface ISecondsCounterProps {
  onSend: () => void;
  onCancel: () => void;
}

export function SecondsCounter({ onSend, onCancel }: ISecondsCounterProps) {
  const SEONDS_BEFORE_POST = 21;
  const [counter, setCounter] = useState(SEONDS_BEFORE_POST);

  useEffect(() => {
    let timer: any;
    if (counter > 0) {
      timer = setInterval(() => setCounter(counter - 1), 1000)
    } else {
      onSend();
    }
    return () => clearInterval(timer);
  }, [counter]);

  return (
    <div className='SecondsCounter'>
      <div className='SecondsCounter__image-seconds-wrapper'>
        <img src={image} className='SecondsCounter__image' alt='finger-down'/>
        <div className='SecondsCounter__counter'>{counter}</div>
      </div>
      <div className='SecondsCounter__text'>
        Seconds till post.
      </div>
      <div className='SecondsCounter__buttons'>
        <Button text='Cancel' buttonType='neutral' handleClick={ onCancel } />
        <Button text='Post Now' buttonType='main' handleClick={ onSend } />
      </div>
    </div>
  );
}
